module.exports = __webpack_public_path__ + "static/media/master.71deee54.svg";